export default {
    i_got_it: 'I got it',
    save: 'Save',
    save_changes: 'Save changes',
    cancel: 'Cancel',
    go_back: 'Go back',
    manage: 'Manage',
    add_new_record: 'Add new record',
    add_forwarder: 'Add forwarder',
    add_catch_all: 'Add Catch-All',
    add_redirect: 'Add redirect',
    add_wildcard_redirect: 'Add wildcard redirect',
    edit_mode: 'Edit mode',
    select_country: '-- Select country --',
    select_province: '-- Select state/province --',
    extend: 'Extend',
    reactivate: 'Reactivate',
    select_duration: '-- Select duration --',
    top_up: 'Top-up',
    withdraw: 'Withdraw',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    skip: 'Skip',
    remove: 'Remove',
    show_more: 'Show more',
    show_less: 'Show less',
    register_now: 'Register Now',
    download_template: 'Download Template',
    send: 'Send',
    resend: 'Resend',
    ok: 'OK',
    new_template: 'New Template',
    select_template: 'Select Template',
    add: 'Add',
    export_report: 'Export Report',
    download: 'Download',
    view_all: 'View All',
    edit: 'Edit',
    change_now: 'Change now',
    change_domain: 'Change domain',
    verify: 'Verify',
    add_new_cloud_server: 'Add new Cloud Server',
    add_new_cloud_hosting: 'Add new Cloud Hosting',
    add_new_shared_hosting: 'Add new Shared Hosting',
    add_new: 'Add New',
    upgrade: 'Upgrade',
    delete: 'Delete',
    save_all_changes: 'Save all changes',
    view_failed_list: 'Failures List',
    pay_now: 'Pay Now',
    apply: 'Apply',
    view_detail: 'View Detail',
    download_receipt: 'Download Receipt',
    download_invoice: 'Download Invoice',
    download_top_up: 'Download Top-up',
    download_vat_invoice: 'Download VAT Invoice',
    invoice: 'Invoice',
    invoices: 'Invoices',
    receipt: 'Receipt',
    vat_invoice: 'VAT Invoice',
    login: 'Login',
    enable: 'Enable',
    disable: 'Disable',
    close: 'Close',
    loading_processing: 'Processing...',
    wp_admin: 'WP Admin',
    upgrade_now: 'Upgrade Now',
    change: 'Change',
    backup_installation: 'Backup Installation',
    activate: 'Activate',
    install: 'Install',
    installed: 'Installed',
    installing: 'Installing',
    restore_installation: 'Restore Installation',
    upload: 'Upload',
    restore: 'Restore',
    reinstall: 'Reinstall',
    revoke: 'Revoke',
    copy: 'Copy',
    access_file: 'Access File',
    access_db: 'Access Database',
    click_here: 'Click here',
    see_more: 'See more',
    confirm_payment: 'Confirm Payment',
    back_to_invoices: 'Back to Invoices',
    done_transfer: 'Done Transfer',
    update_information: 'Update Information',
    yes: 'Yes',
    no: 'No',
    no_later: 'No, Later',
    buy_domains: 'Buy Domains',
    reissue: 'Reissue',
    active: 'Active',
    read_more: 'Read more',
    submit: 'Submit',
    got_it: 'Got it',
    edit_method: 'Edit Method',
    get_record: 'Get Record',
    resend_mail: 'Resend Mail',
    download_file: 'Download File',
    decode: 'Decode',
    done: 'Done',
    change_email: 'Change email',
    see_history: 'See History',
    detail: 'Detail',
    create_new: 'Create New',
    enable_backup: 'Enable Backup',
    disable_backup: 'Disable Backup',
    change_os: 'Change/Reinstall OS',
    restoring: 'Restoring',
    try_demo: 'Try Demo',
    here: 'here',
    search: 'Search',
    credit_note: 'Credit Note',
    download_credit_note: 'Download Credit Note',
    print: 'Print',
    expand_all: 'Expand All',
    collapse_all: 'Collapse All',
    continue_with_google: 'Continue with Google',
    continue: 'Continue',
    try_again: 'Try again',
    contracts: 'Contracts',
    contract: 'Contract',
    download_contract: 'Download Contract',
    accept_and_confirm: 'Accept & Confirm',
};
